import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./views/Home";
import Address from "./views/Step10_Address";
import Ticket from "./views/Step15_Ticket";
import AdditionalInformation from "./views/Step17_AdditionalInformation";
import Checkout from "./views/Step20_Checkout";
import Confirmation from "./views/Step30_Confirmation";
import ClosedRegistration from "./views/_ClosedRegistration";

import "./css/style.css";
import "./css/progress-bar.css";

function App() {
  return (
    <BrowserRouter>
          <Routes>
              {/*<Route path="/" element={<Navigate to="/de/home" replace />} />*/}
              {/*<Route path="/:language/home" element={<ClosedRegistration />} />*/}


            <Route path="/" element={<Navigate to="/de/home" replace />} />
            <Route path="/:language/home" element={<Home />} />
            <Route path="/:language/address" element={<Address />} />
            <Route path="/:language/ticket" element={<Ticket />} />
            <Route path="/:language/additional-information" element={<AdditionalInformation />} />
            <Route path="/:language/checkout" element={<Checkout />} />
            <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
              <Route path="/:language/confirmation" element={<Confirmation />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
